<div class="specificatii" [innerHtml]="htmlSpecificatii">
</div>
